import { useMemo } from 'react'

import { Table as DSTable, TableAlign } from '@vr/ds-react'

import { LIST_COLUMNS } from '@/constants/list-columns'

export const UnitsList = ({ list }: { list: any[] }) => {
  const mappedData = useMemo(() => {
    return list.map(item => {
      return {
        ...item
      }
    })
  }, [list])

  return (
    <DSTable
      skeleton={{
        columns: 2,
        rows: 10
      }}
      css={{ width: '100%', marginTop: '20px' }}
    >
      <DSTable.Head>
        <DSTable.Cell align='center' colSpan={LIST_COLUMNS.length}>
          FILIAIS
        </DSTable.Cell>
      </DSTable.Head>
      <DSTable.Head>
        {LIST_COLUMNS.map(item => (
          <DSTable.Cell
            key={item.field}
            id={item.field}
            align={item.align as TableAlign}
          >
            {item.headerName}
          </DSTable.Cell>
        ))}
      </DSTable.Head>
      <DSTable.Body>
        {mappedData.map(item => (
          <DSTable.Row key={item.id} id={item.id?.toString()}>
            {LIST_COLUMNS.map(key => (
              <DSTable.Cell
                key={key.field}
                align={key.align as TableAlign}
                css={{ padding: 0 }}
              >
                {item[key.field as keyof typeof item]}
              </DSTable.Cell>
            ))}
          </DSTable.Row>
        ))}
      </DSTable.Body>
    </DSTable>
  )
}
